"use client";
import { PropsWithChildren } from "react";
import { IntercomProvider, type IntercomProviderProps } from "react-use-intercom";

const IntercomIntegration = ({
  enabled,
  ...props
}: PropsWithChildren<IntercomProviderProps & { enabled?: boolean }>) => {
  // if (!enabled) return props.children;
  return <IntercomProvider {...props} />;
};

export default IntercomIntegration;
